export default from './category-list-item-masonry';



// WEBPACK FOOTER //
// ./app/components/category-list-item-masonry/index.js